import { ca } from '@cian/analytics';

import { getCustomUrl, getTrackingProducts } from '../../utils/tracking';

export const trackShowPhoneClick = (builderId: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Phones',
    action: 'Open_card_builder_contact_block_card',
    label: getCustomUrl(builderId),
    products: getTrackingProducts(builderId),
  });
};
